import { Typography } from "@mui/material";
import { motion } from "framer-motion";

function CoupleNameAndDate() {
  return (
    <>
      <Typography
        component={motion.h1}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
        variant="h1"
        sx={{
          fontFamily: '"Playfair Display", Georgia, serif',
          fontSize: { xs: "2.5rem", sm: "3.5rem" },
          fontWeight: 400,
          color: "#1a3a52",
          letterSpacing: "1px",
          mb: 0,
        }}
      >
        Isabela & Tiago
      </Typography>

      <Typography
        component={motion.h5}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
        variant="h5"
        sx={{
          fontFamily: '"Open Sans", sans-serif',
          fontSize: { xs: "1rem", sm: "1.25rem" },
          fontWeight: 300,
          color: "#2d4e66",
          letterSpacing: "2px",
          textTransform: "uppercase",
          mb: -1,
        }}
      >
        4 de julho de 2026 • Alenquer, Portugal
      </Typography>
    </>
  );
}

export default CoupleNameAndDate;
